import { render, staticRenderFns } from "./PaginationAndTableInfo.vue?vue&type=template&id=76028ed4"
import script from "./PaginationAndTableInfo.vue?vue&type=script&lang=js"
export * from "./PaginationAndTableInfo.vue?vue&type=script&lang=js"
import style0 from "./PaginationAndTableInfo.vue?vue&type=style&index=0&id=76028ed4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports